import type { JSX } from 'react';
import { Alert, List } from '@ksyos/design-system';
import type { HeadacheReferralData } from '@common/validation/customControls/neurology/headache/headacheReferral/headacheReferral';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { useProcessActivityEditContext } from '@frontend/utils';

export function ExclusiecriteriaGelezen(): JSX.Element {
    const { data, errors } = useProcessActivityEditContext<HeadacheReferralData>();
    const { onChange } = useEditFormSectionInputFieldContext();

    const key = 'exclusiecriteria_gelezen';
    const hasError = errors.has(key);
    const isChecked = Boolean(data[key]);

    return (
        <Alert
            appearance={hasError ? 'warning' : 'info'}
            className={hasError ? 'has-danger' : ''}
        >
            Exclusiecriteria
            <List
                size="small"
                styleType="counter"
                sx={{ mt: 2 }}
            >
                <List.Item>Nieuwe focale neurologische uitvalsverschijnselen</List.Item>
                <List.Item>
                    Voorgeschiedenis maligniteit, immuuncomprommiterende aandoeningen of immuunsuppressieve medicatie
                </List.Item>
                <List.Item>
                    Recent trauma (&lt; 6 weken) met bijkomende symptomen (neurologische uitval, cognitieve
                    verandering), gebruik van anticoagulantia en/of een leeftijd ≥ 60 jaar
                </List.Item>
                <List.Item>Epileptische insulten bij patiënt zonder epilepsie in voorgeschiedenis</List.Item>
                <List.Item>Progressief braken (zonder diarree of koorts)</List.Item>
            </List>
            <Alert.Checkbox
                checked={isChecked}
                label={
                    <Alert.Text
                        as="span"
                        size="sm"
                    >
                        Ik heb de exclusiecriteria gelezen en ga akkoord*
                    </Alert.Text>
                }
                onChange={(event) => onChange(event.target.checked)}
                sx={{ mt: 4 }}
            />
        </Alert>
    );
}
